module.exports = __webpack_public_path__ + "static/media/de.5ff6a907.mp3";